
import viewer from "../../workers/ViewerEngine";
import * as Enumerations from "../../../Enumerations/Enumerations";
import * as Interfaces from "../../../Interfaces/Interfaces";
import * as BABYLON from 'babylonjs';
import * as Data from "../../Data/WebData";
import EventManager from '../../Managers/EventManager';
import Viewer3DConstants from '../../../constants/Viewer3DConstants';
import Viewer3DActions from '../../../actions/Viewer3DActions';
import Viewer3DEvents from '../../../constants/Viewer3DEvents';
abstract class Viewer {
    protected _divContainer: HTMLDivElement;
    protected _viewerEngine: viewer;
    protected _canvas: HTMLCanvasElement;
    protected _fillStyle: Enumerations.ViewerFillStyle = Enumerations.ViewerFillStyle.FIT;
    protected _eventManager: EventManager;
    
    protected _canvasSize: { height: number, width: number };
    
    constructor(div: HTMLDivElement) {

        this._eventManager = new EventManager();
        this._divContainer = div;
        this._canvasSize = { height: null, width: null };
    }

    protected _addEventListeners() {
        window.addEventListener('resize', this._resizeCanvas);
    }

    protected _removeEventListeners() {
        window.removeEventListener('resize', this._resizeCanvas);
    }

    protected _fireStartBlockingOperation() {
        this._eventManager.fireEvent(Viewer3DEvents.VIEWER_BUSY as any, null);
    }

    protected _fireEndBlockingOperation() {
        this._eventManager.fireEvent(Viewer3DEvents.VIEWER_IDLE as any, null);
    }

    public getCanvasSize() {
        if (this._canvasSize.width && this._fillStyle == Enumerations.ViewerFillStyle.FIT) {
            return this._canvasSize;
        } else {
            return {
                width: this._canvas.width, height: this._canvas.height
            };
        }
    }

    public getScaleRatio() {
        if (this._fillStyle == Enumerations.ViewerFillStyle.FIT && this._canvasSize.height && this._canvasSize.width) {
            return this._canvas.height / this._canvasSize.height;
        }

        return 1;
    }

    public getActualCanvasSize() {
        return {
            width: this._canvas.clientWidth,
            height: this._canvas.clientHeight
        };
    }

    public setCanvasSize(width: number, height: number) {
        this._canvasSize.width = width;
        this._canvasSize.height = height;
        this._resizeCanvas();
    }

    public abstract registerEvent(eventType: string, cb: (e: Interfaces.Interfaces.IEventObject) => void): void;
    protected abstract _resizeCanvas(): void;
}

export default Viewer;